import FeaturesApi from '@/services/Api/FeaturesApi'

const state = () => ({
  disabledFeatures: [],
  loaded: false
})

const getters = {
  disabledFeatures (state) {
    return state.disabledFeatures
  },
  isFeatureEnabled (state, getters) {
    return feature => {
      return !getters.disabledFeatures.includes(feature)
    }
  },
  loaded (state) {
    return state.loaded
  }
}

const actions = {
  loadDisabledFeatures ({ commit }) {
    return FeaturesApi.fetchDisabled()
      .then(({ payload }) => {
        commit('setDisabledFeatures', payload.disabled)
        commit('setLoaded')
      })
  }
}

const mutations = {
  setDisabledFeatures (state, disabledFeatures) {
    state.disabledFeatures = disabledFeatures
  },
  setLoaded (state) {
    state.loaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export const FEATURES = {
  CARD_ISSUING: 'card-issuing',
  DEPOSITS: 'deposits',
  VIRTUAL_CARDS: 'virtual-cards',
  SAVINGS_ACCOUNTS: 'savings-accounts',
  PAYMENTS_V2_SEPA_FIELDS: 'payments-v2-sepa-fields'
}
